var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPianyi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25_1858)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.4669 8.72848H10.9636V2.90067H6.59272V8.72848H2.35431V13.0993H15.4669",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 7.03974H13.0166V0.947021H4.67219V7.03974H0.5V15.053H15.5",
    stroke: "#00C2FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25_1858"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPianyi);
export default __webpack_public_path__ + "static/media/pianyi.c531f3f0299d4df72270ff677582d699.svg";
export { ForwardRef as ReactComponent };